import get from "lodash/get";
import { FIELD_CUSTOM_FIELDS_KEY } from "PFApp/constants/activity_form/activity_form_field_keys";
import { useFormValidation } from "PFApp/hooks/activity_form/use_form_validation";
import { Sections } from "PFApp/types/activity_form/activity_form_schema";
import { ParsedSchemaProperty } from "PFCore/types";
import { useMemo } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { useActivityFormStore } from "../../activity_form_store";
import { isFieldBlank } from "../../helpers";
import { useSubtemplate } from "../../hooks/use_subtemplate";
import { FieldFactory } from "../components/field_factory/field_factory";
import { FormSection, SectionProps } from "../form_section";

export const MatchAttributesFormSection = ({ id, title }: SectionProps) => {
  const {
    control,
    formState: { errors }
  } = useFormContext();
  const { t } = useTranslation("activities");
  const template = useActivityFormStore((state) => state.template);
  const formSchema = useActivityFormStore((state) => state.formSchema);
  const { draft: submittedAsDraft } = useActivityFormStore((state) => state.submitOptions);
  const subtemplate = useSubtemplate();
  const { isFieldRequired } = useFormValidation({ subtemplate, template });

  const matchProperties = useMemo(() => formSchema![Sections.MatchAttributes]!, [formSchema]);

  return (
    <FormSection id={id} title={title}>
      {matchProperties.map((field) => {
        const property = field.property as ParsedSchemaProperty;
        const required = isFieldRequired(field);

        return (
          <Controller
            key={property.name}
            name={`${FIELD_CUSTOM_FIELDS_KEY}.${property.name}`}
            control={control}
            rules={{
              validate: (value: string) => {
                if (!submittedAsDraft && required && isFieldBlank(value)) {
                  return t("form.errors.cantBeBlank");
                }
                return true;
              }
            }}
            render={({ field }) => (
              <FieldFactory
                property={property}
                value={field.value || []}
                error={
                  (get(errors, field.name)?.message as string) ||
                  (get(errors, property.name)?.message as string)
                }
                onChange={field.onChange}
                required={required}
              />
            )}
          />
        );
      })}
    </FormSection>
  );
};
